(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["component-fabric-showcase"] && !Shopify.designMode) return;
  try {
    
  function knobbyNormalizeFabricMaterial(handle) {
    var normalized = (handle || '').toString().trim().toLowerCase();
    return normalized === 'naturals' ? 'naturals' : 'bottleblend';
  }

  function knobbySyncFabricProductImage(panel, styleKey) {
    if (!panel || !styleKey) return;

    var imageMap = {};
    try {
      imageMap = JSON.parse(panel.getAttribute('data-pdp-style-images') || '{}');
    } catch (error) {
      imageMap = {};
    }

    var productImage = panel.querySelector('[data-pdp-fabric-product-image]');
    if (!productImage) return;

    var nextSrc = imageMap[styleKey] || imageMap.trunk || productImage.dataset.src;
    if (nextSrc && window.knobbyPdpComponentImage?.updateSrc) {
      window.knobbyPdpComponentImage.updateSrc(productImage, nextSrc);
    }
  }

  function knobbySyncFabricShowcase(materialHandle, styleKey) {
    if (!materialHandle) return;

    var material = knobbyNormalizeFabricMaterial(materialHandle);

    document.querySelectorAll('[data-pdp-showcase="fabric"]').forEach(function (section) {
      section.setAttribute('data-pdp-material', material);
      if (styleKey) section.setAttribute('data-pdp-style', styleKey);
    });

    document.querySelectorAll('[data-pdp-material-panel]').forEach(function (panel) {
      var isActive = panel.getAttribute('data-pdp-material-panel') === material;
      panel.classList.toggle('component-fabric-showcase__panel--active', isActive);
      if (isActive) knobbySyncFabricProductImage(panel, styleKey);
    });
  }

  window.knobbySyncFabricShowcase = knobbySyncFabricShowcase;

  window.addEventListener('knobby:pdp-material-change', function (event) {
    var detail = event && event.detail ? event.detail : {};
    knobbySyncFabricShowcase(detail.material, detail.style);
  });

  window.dispatchEvent(new CustomEvent('knobby:fabric-showcase-ready'));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portal-dashboard"]) return;
  try {
    
  ;(() => {
    const frame = document.querySelector('.portal-dashboard__frame[data-knobby-portal-url]')
    if (!frame) return

    const portalUrl = frame.dataset.knobbyPortalUrl || 'https://portal.knobby.com.au'
    const portalTrustedOrigins = ['https://portal.knobby.com.au']
    const storefrontHostname = window.location.hostname

    function buildPortalEmbedUrl() {
      const url = new URL(portalUrl)
      url.searchParams.set('embed', '1')
      url.searchParams.set('parent_origin', window.location.origin)
      return url.toString()
    }

    function syncHeaderOffset() {
      const header =
        document.querySelector('.header-section') ||
        document.querySelector('#component-header') ||
        document.querySelector('#shopify-section-component-header')
      const offset = header ? Math.round(header.getBoundingClientRect().bottom) : 0
      document.documentElement.style.setProperty('--portal-dashboard-header-offset', offset + 'px')
    }

    function isStorefrontUrl(href) {
      if (!href) return false
      try {
        const url = new URL(href, window.location.origin)
        if (url.protocol !== 'http:' && url.protocol !== 'https:') return false
        if (url.origin === window.location.origin) return true
        if (url.hostname === storefrontHostname) return true
        return url.hostname.endsWith('.knobby.com.au') && !url.hostname.startsWith('portal.')
      } catch (_) {
        return false
      }
    }

    function handlePortalMessage(event) {
      if (!portalTrustedOrigins.includes(event.origin)) return
      const data = event.data
      if (!data) return

      if (typeof data === 'string' && isStorefrontUrl(data)) {
        window.location.assign(new URL(data, window.location.origin).href)
        return
      }

      if (typeof data !== 'object') return

      const messageType = data.type || data.action
      const href = data.url || data.href || data.location || data.payload?.url

      if (
        messageType === 'knobby-portal-navigate' ||
        messageType === 'knobby-portal-exit' ||
        messageType === 'navigate'
      ) {
        if (href && isStorefrontUrl(href)) {
          window.location.assign(new URL(href, window.location.origin).href)
        }
      }
    }

    syncHeaderOffset()
    window.addEventListener('resize', syncHeaderOffset)
    window.addEventListener('message', handlePortalMessage)
    frame.src = buildPortalEmbedUrl()
  })()

  } catch(e) { console.error(e); }
})();
})();
